// extracted by mini-css-extract-plugin
export var marginNegative = "_75-5 _75-3 _75-1";
export var marginPositive = "_75-4 _75-3 _75-1";
export var modalContent = "_75-6";
export var samplesTable = "_75-8";
export var samplesTableContainer = "_75-7";
export var statBox = "_75-a";
export var tableCell = "_75-1";
export var tableCellCenter = "_75-2 _75-1";
export var tableCellRight = "_75-3 _75-1";
export var tableHeader = "_75-0";
export var trackingNumber = "_75-9";